import { Fingerprint } from '@gravity-ui/icons';

import useStartIdentifierPasskeySignInProcessing from '@/hooks/use-start-identifier-passkey-sign-in-processing';
import { type VerificationCodeIdentifier } from '@/types';

import MethodSwitchButton from './MethodSwitchButton';

type Props = {
  readonly className?: string;
  readonly identifier: VerificationCodeIdentifier;
  readonly value: string;
};

const PasskeySignInLink = ({ className, identifier, value }: Props) => {
  const { startProcessing: onClickPasskeySignInMethod, isProcessing } =
    useStartIdentifierPasskeySignInProcessing({
      hideErrorToast: false,
    });

  return (
    <MethodSwitchButton
      className={className}
      icon={<Fingerprint />}
      text="action.sign_in_via_passkey"
      isLoading={isProcessing}
      onClick={async () => {
        if (isProcessing) {
          return;
        }

        await onClickPasskeySignInMethod({ type: identifier, value });
      }}
    />
  );
};

export default PasskeySignInLink;
